"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStateCenterCoordinates = exports.getGeoPath = exports.getAlbersScale = exports.MIN_HEIGHT = exports.MAP_STROKE_COLOR = exports.USAMAP_WIDTH_TO_HEIGHT_RATIO = exports.USAMAP_WIDTH_RATIO = exports.USAMAP_X_OFFSET = void 0;
/* eslint-disable react-hooks/rules-of-hooks */
const d3 = __importStar(require("d3"));
const prop_types_1 = require("prop-types");
const react_1 = __importStar(require("react"));
const topojson = __importStar(require("topojson-client"));
const colors_1 = require("../../utilities/colors");
const measurements_1 = require("../../utilities/measurements");
const states_10m_json_1 = __importDefault(require("./states-10m.json"));
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
const [albersX, albersY] = d3.geoAlbersUsa().translate();
const stateFeatureCollection = topojson.feature(states_10m_json_1.default, states_10m_json_1.default.objects.states);
// the 1.85 multiplier and x adjustment are because the map isn't as wide as albersX reports
// these numbers were determined visually
exports.USAMAP_X_OFFSET = 20;
exports.USAMAP_WIDTH_RATIO = 1.7;
exports.USAMAP_WIDTH_TO_HEIGHT_RATIO = albersX * exports.USAMAP_WIDTH_RATIO / (albersY * 2);
exports.MAP_STROKE_COLOR = '#FFFFFF';
exports.MIN_HEIGHT = 100;
const getAlbersScale = mapWidth => (mapWidth + exports.USAMAP_X_OFFSET) / albersX;
exports.getAlbersScale = getAlbersScale;
const getGeoPath = (width, height) => {
  const projection = d3.geoAlbersUsa().fitSize([width, height], stateFeatureCollection);
  return d3.geoPath(projection);
};
exports.getGeoPath = getGeoPath;
const getStateCenterCoordinates = (fips, mapWidth, mapHeight) => {
  const stateCoordinates = [];
  stateFeatureCollection.features.forEach(feature => {
    if (feature.id === fips) {
      stateCoordinates.push({
        coordinates: feature.geometry.coordinates,
        fips: feature.id
      });
    }
  });
  const geoPath = (0, exports.getGeoPath)(mapWidth, mapHeight);
  return geoPath.centroid(stateFeatureCollection.features.find(feature => feature.id === fips));
};
exports.getStateCenterCoordinates = getStateCenterCoordinates;
const USAMap = _ref => {
  let {
    data = [],
    strokeColor: defaultStrokeColor = exports.MAP_STROKE_COLOR,
    backgroundColor = 'usa-gray',
    height: rawHeight = undefined,
    width: rawWidth = 425.5,
    onMouseOver = () => {},
    onMouseOut = () => {},
    onClick = () => {}
  } = _ref;
  if (rawWidth === 0) {
    return null;
  }
  const {
    width,
    height
  } = (0, measurements_1.getMapDimensions)(exports.USAMAP_WIDTH_RATIO, rawWidth, rawHeight);
  if (height < exports.MIN_HEIGHT) {
    console.warn(`Height cannot be lower than ${exports.MIN_HEIGHT}.`);
  }
  const albersScale = (0, react_1.useMemo)(() => (0, exports.getAlbersScale)(width, height), [width, height]);
  const pathProps = (0, react_1.useMemo)(() => {
    const geoPath = (0, exports.getGeoPath)(width, height);
    return stateFeatureCollection.features.map(feature => ({
      fips: feature.id,
      path: geoPath(feature)
    })).filter(_ref2 => {
      let {
        path
      } = _ref2;
      return path;
    }).map(_ref3 => {
      let {
        fips,
        path
      } = _ref3;
      const {
        stateBackgroundColor = backgroundColor,
        strokeColor,
        strokeWidth = 1
      } = data.find(_ref4 => {
        let {
          fips: metricFips
        } = _ref4;
        return fips === metricFips;
      }) || {};
      return {
        path,
        fill: (0, colors_1.parseColor)(stateBackgroundColor, 'usa-gray'),
        strokeWidth: Math.ceil(strokeWidth * albersScale),
        stroke: (0, colors_1.parseColor)(strokeColor || defaultStrokeColor, exports.MAP_STROKE_COLOR),
        sortToFront: strokeColor !== undefined,
        fips,
        opacity: 1
      };
    }).sort((a, b) => a.sortToFront - b.sortToFront);
  }, [width, height, albersScale, data, backgroundColor, defaultStrokeColor]);
  return react_1.default.createElement("g", {
    className: styles_module_css_1.default['usa-map'],
    style: {
      width,
      height
    }
  }, pathProps.map(_ref5 => {
    let {
      fill,
      strokeWidth,
      stroke,
      path,
      fips
    } = _ref5;
    return react_1.default.createElement("path", {
      key: fips,
      className: styles_module_css_1.default[`state-${fips}`],
      d: path,
      fill: fill,
      strokeWidth: strokeWidth,
      stroke: stroke,
      onMouseOver: event => onMouseOver(event, fips),
      onMouseOut: event => onMouseOut(event, fips),
      onClick: event => onClick(event, fips)
    });
  }));
};
USAMap.propTypes = {
  /**
   * State data to display on the map, indexed by fips number (string).
   * Each state has a stateBackgroundColor (string), strokeColor (string),
   * and strokeWidth (number).
   * Border strokes with defined colors will appear on top of those with undefined color.
   */
  data: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    strokeColor: prop_types_1.string,
    strokeWidth: prop_types_1.number,
    stateBackgroundColor: prop_types_1.string,
    fips: prop_types_1.string.isRequired
  })),
  /**
   * default state stroke color
   */
  strokeColor: prop_types_1.string,
  /**
   * default state background color
   */
  backgroundColor: prop_types_1.string,
  /**
   * Height for the map. The map will automatically set it's width to maintain it's aspect ratio. Will override provided width
   */
  height: prop_types_1.number,
  /**
   * Width for the map. The map will automatically set it's height to maintain it's aspect ratio.
   */
  width: prop_types_1.number,
  /**
   * function to activate on click
   * parameters: (event, fips)
   */
  onClick: prop_types_1.func,
  /**
   * function to activate on mouseOver
   * parameters: (event, fips)
   */
  onMouseOver: prop_types_1.func,
  /**
   * function to activate on mouseOut
   * parameters: (event, fips)
   */
  onMouseOut: prop_types_1.func
};
exports.default = USAMap;